import { createIcon } from "@chakra-ui/react";

export const UploadCloud = createIcon({
  displayName: "UploadCloud",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.405 6.532a1.803 1.803 0 0 1-2.096-.468A4.499 4.499 0 0 0 5.4 9v.008a1.8 1.8 0 0 1-1.2 1.698A3.6 3.6 0 0 0 5.4 17.7h13.624a.452.452 0 0 1 .071-.008 3.297 3.297 0 0 0 1.125-6.315 1.805 1.805 0 0 1-1.054-1.938 2.698 2.698 0 0 0-3.761-2.906zm3.795 12.96v.008H5.4A5.401 5.401 0 0 1 3.6 9.008V9a6.3 6.3 0 0 1 6.3-6.3c1.909 0 3.615.847 4.774 2.186A4.499 4.499 0 0 1 21 9c0 .244-.019.488-.056.724a5.104 5.104 0 0 1-1.744 9.768zm-3.56-8.728-3-3a.896.896 0 0 0-1.272 0l-3 3a.9.9 0 0 0 1.271 1.271l1.463-1.462v5.029c0 .499.401.9.9.9.498 0 .9-.401.9-.9v-5.029l1.462 1.463a.9.9 0 0 0 1.271-1.271h.004z"
    />,
  ],
  defaultProps: {
    "aria-label": "Upload icon: An arrow pointing up within a hollow cloud"
  }
});

export default UploadCloud;
